<!-- <h1 mat-dialog-title>Edit {{ data.field }}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ data.field }}</mat-label>
    <input matInput [(ngModel)]="data.value">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data.value" cdkFocusInitial>Save</button>
</div> -->


<h1 mat-dialog-title>Edit {{ data.field }}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Title</mat-label>
    <input matInput [(ngModel)]="data.value.title">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="data.value.date">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Color</mat-label>
    <input matInput [(ngModel)]="data.value.color">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data.value" cdkFocusInitial>Save</button>
</div>
